/**
 * @file Renders the investment drawer's title with the investment name and ID.
 */
import { Tag, Row, Col, Typography } from "antd";

import { W1, DRAWER_WIDTH3 } from "@components/Constants";

import type { Investment } from "./types";

const TITLE_RESERVED_WIDTH = 180;

const TITLE_STYLE = {
  margin: 0,
  maxWidth: `${DRAWER_WIDTH3 - TITLE_RESERVED_WIDTH}px`,
};

type Props = {
  investment?: Investment;
};

/**
 * Renders the investment's name and ID as the drawer title, or nothing when there is no investment.
 */
const Title = ({
  investment = undefined,
}: Props) => {
  if (!investment) {
    return null;
  }

  const { name, id } = investment;

  const title = (
    <Typography.Title level={5} style={TITLE_STYLE} ellipsis>
      {name}
    </Typography.Title>
  );

  return (
    <Row gutter={[ W1, W1 ]}>
      <Col flex="auto">
        {title}
      </Col>
      <Col>
        <Tag bordered={false}>
          {id}
        </Tag>
      </Col>
    </Row>
  );
};

export default Title;
